import React from "react";
import { Form, Input, Button, Card, Row, Col } from "antd";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import logo from "../graphics/logo.svg";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../redux-toolkit/store/store";
import { loginApi } from "../redux-toolkit/slices/authSlice";
import useMultiNotification from "../hooks/useNotification";
import { setAuthToken } from "../helpers/userDetails";
const LoginForm = () => {
  const dispatch = useAppDispatch();
  const authState = useSelector((state: RootState) => state.auth);
  const { contextHolder, openNotification } = useMultiNotification();

  const [form] = Form.useForm();
  const onFinish = async (values: ILoginApi) => {
    // dispatch(loginApi(value));
    try {
      const user = await dispatch(loginApi(values)).unwrap();
      const token = user.responseData;
      setAuthToken(token);
      window.location.href = "/";
    } catch (error) {
      if (typeof error === "string") {
        openNotification(`error`, `Login Failed`, error);
      } else {
        openNotification(`error`, `Login Failed`, `Server Error`);
      }
    }
  };
  const onFinishFailed = (data: any) => {};
  return (
    <>
      {contextHolder}
      <Row
        style={{ minHeight: "100vh", padding: "0 20px" }} // Added padding here for small screens
        justify="center"
        align="middle"
      >
        <Col xs={24} sm={20} md={16} lg={12} xl={8}>
          <div style={{ textAlign: "center" }}>
            <img
              src={logo}
              alt="Twinge Health Logo"
              style={{ width: "50%", marginTop: "40px", marginBottom: "40px" }}
            />
          </div>

          <Card>
            <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
              Welcome Back
            </h2>
            <Form
              name="loginForm"
              initialValues={{ remember: true }}
              layout="vertical"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Please input your email!" },
                ]}
              >
                <Input prefix={<MailOutlined />} placeholder="Email" />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Password"
                />
              </Form.Item>

              <Form.Item>
                <div style={{ textAlign: "right", marginTop: "-10px" }}>
                  <a href="/forgotpassword">Forgot password?</a>
                </div>
              </Form.Item>

              <Form.Item>
                <Button
                  disabled={authState.isSubmitting}
                  type="primary"
                  htmlType="submit"
                  block
                >
                  Log in
                </Button>
              </Form.Item>
            </Form>
          </Card>

          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <span>New to Twinge Health? </span>
            <Link to="/signup">Create account</Link>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default LoginForm;
